/**
 * User `source` values from API/signup that trigger the post-signup partner subscription offer dialog.
 * Add new partner slugs here as the backend starts returning them on `user.source`.
 */
export const PARTNER_SUBSCRIPTION_OFFER_USER_SOURCES: readonly string[] = ['benefithub'];

export function isPartnerSubscriptionOfferSource(source: string | undefined | null): boolean {
  return !!source && PARTNER_SUBSCRIPTION_OFFER_USER_SOURCES.includes(source);
}
